import mutationTypes from '../store/mutation-types';

/**
 * 数组分组
 */
export const groupBy = (array, fun) => {
  let groups = {};
  let result = {};
  array.forEach(function (o) {
    let group = JSON.stringify(fun(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  Object.keys(groups).map(function (group) {
    result[group] = groups[group];
  });
  return result;
}

/**
 * Hash修改后执行函数
 */
export const hashAfterEach = (store) => {
  (function () {
    if (!window.HashChangeEvent) {
      var lastURL = document.URL;
      window.addEventListener("hashchange", function (hashEvent) {
        var oldURL = lastURL;
        var newURL = document.URL;
        lastURL = newURL;
        Object.defineProperties(hashEvent, {
          oldURL: { enumerable: true, configurable: true, value: oldURL },
          newURL: { enumerable: true, configurable: true, value: newURL }
        });
        handle(newURL);
      });
    } else {
      window.addEventListener("hashchange", function (hashEvent) {
        let { newURL } = hashEvent;
        newURL = newURL.split('#')[1];
        handle(newURL);
      });
    }
  }());

  let hashUrl = window.location.hash.split('#')[1] || '/';
  handle(hashUrl);


  function handle(hashUrl) {
    if (hashUrl === '/') {
      window.location.hash = '/console/#/main/overview';
    }

    if (hashUrl.endsWith('create')) {
      //创建实例页面隐藏region选框和左边菜单
      store.commit(mutationTypes.SET_IS_CREATE_PAGE, true);
    } else {
      store.commit(mutationTypes.SET_IS_CREATE_PAGE, false);
    }

    if (
      hashUrl.endsWith('create') ||
      hashUrl.indexOf('workorder') > 0 || hashUrl.indexOf('expense') > 0 ||
      hashUrl.indexOf('overview') > 0 || hashUrl.indexOf('iam') > 0 ||
      hashUrl.indexOf('detail') > 0 || hashUrl === '/d') {
      //概览、费用中心、工单、个人中心、控制台首页，去掉region选框
      store.commit(mutationTypes.SET_IS_SHOW_REGION_SELECT, false);
    } else {
      store.commit(mutationTypes.SET_IS_SHOW_REGION_SELECT, true);
    }
  }
}

/**
 * 检测浏览器兼容
 */
export const checkBrowserVersion = (context) => {
  let userAgent = process.server ? context.req.headers['user-agent'] : navigator.userAgent;
  userAgent = userAgent.toLowerCase();
  let versionObject = { browser: "", version: 0, compatible: false };
  if (userAgent.indexOf("firefox") > -1) {
    //is firefox
    versionObject.browser = "firefox";
    versionObject.version = userAgent.match(/firefox\/[\d.]+/gi)[0].split("/")[1].split(".")[0];
    if (versionObject.version - 0 >= 41) {
      versionObject.compatible = true;
    }
  } else if (userAgent.indexOf("chrome") > -1) {
    //is chrome
    versionObject.browser = "chrome";
    versionObject.version = userAgent.match(/chrome\/[\d.]+/gi)[0].split("/")[1].split(".")[0];
    if (versionObject.version - 0 >= 41) {
      versionObject.compatible = true;
    }
  } else if (userAgent.indexOf("opera") > -1) {
    //is opera
    versionObject.browser = "opera";
    versionObject.version = userAgent.match(/opera\/[\d.]+/gi)[0].split("/")[1].split(".")[0];
    if (versionObject.version - 0 >= 41) {
      versionObject.compatible = true;
    }
  } else if (userAgent.indexOf("safari") > -1) {
    //is opera
    versionObject.browser = "safari";
    versionObject.version = userAgent.match(/version\/[\d.]+/gi)[0].split("/")[1].split(".")[0];
    if (versionObject.version - 0 >= 9) {
      versionObject.compatible = true;
    }
  } else if (userAgent.indexOf("ucbrowser") > -1) {
    //is ucbrowser
    versionObject.browser = "ucbrowser";
    versionObject.version = userAgent.match(/ucbrowser\/[\d.]+/gi)[0].split("/")[1].split(".")[0];
    if (versionObject.version - 0 >= 6) {
      versionObject.compatible = true;
    }
  } else if (userAgent.indexOf("edge") > -1) {
    //is firefox
    versionObject.browser = "edge";
    let vstring = userAgent.match(/edge\/[\d.]+/gi)[0].split("/")[1].split(".");
    if (vstring.length > 1) {
      versionObject.version = vstring[0] + "." + vstring[1];
    } else {
      versionObject.version = vstring[0];
    }
    if (versionObject.version - 0 >= 0.33) {
      versionObject.compatible = true;
    }
  } else if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("msie") > -1) {
    versionObject.browser = "ie"
    let reIe = new RegExp("msie (\\d+\\.\\d+);");
    reIe.test(userAgent);
    versionObject.version = parseFloat(RegExp["$1"]);
    if (versionObject.version - 0 > 9) {
      versionObject.compatible = true;
    }
  } else if (userAgent.indexOf('trident') > -1 && userAgent.indexOf("rv:11.0") > -1) {
    versionObject.browser = "ie";
    versionObject.version = 11;
    versionObject.compatible = true;
  } else {
    versionObject.browser = "fkbrowser";
    versionObject.version = "godKnows";
    versionObject.compatible = false;
  }
  return versionObject.compatible;
}